import { styled } from 'styled-components'

export const StyledPageContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-self: center;
  gap: 48px;
`

export const StyledPaywallContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 48px;
`
